import React from 'react';
import { isUserEventOwner, isCurrentUserEventInstructor } from 'utils/event-utils';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';
import { IdentityService, Roles } from 'services/identity-service';

interface Props {
  eventFormStore: EventFormStore;
  identityService: IdentityService;
  readOnly: boolean;
  onRequestChanges?: () => void;
}

const EventRequestChangesButtonTw: React.FC<Props> = ({ eventFormStore, identityService, readOnly, onRequestChanges }) => {
  const event: EventFormViewModel = eventFormStore.state.item;
  if (!event || !event.eventType) return null;

  const isVisible =
    (event.status.toString() === 'InProgress' || event.status.toString() === 'Planned') &&
    !isUserEventOwner(event) &&
    (!identityService.isInRole(Roles.Instructor) || isCurrentUserEventInstructor(event)) &&
    !identityService.isInRole(Roles.Employee) &&
    !identityService.isInRole(Roles.Reporting);

  if (!isVisible) return null;

  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      disabled={!readOnly}
      onClick={onRequestChanges}
    >
      Request Changes
    </button>
  );
};

export default EventRequestChangesButtonTw;
